import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Select,Timeline   } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import left from '../../assets/images/icon/next.png';
import right from '../../assets/images/icon/return.png';
import person from '../../assets/images/icon/person.png';
import deliveryman from '../../assets/images/icon/delivery-man.png';
import car from '../../assets/images/icon/car.png';
import bus from '../../assets/images/icon/bus_route.png';

const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}
const item_name = [];
function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
  const item_name = checkedValues;
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			item_name: item_name,
			value: '',
			checkedList: defaultCheckedList,
			indeterminate: true,
			checkAll: false,
			tabs: '1',
			route_id: '',
			tag: '',
			school_list: [],
			route_list: [],
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {school_id : school_id,user_id : user_id,}
			getData('erp/route_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							//tabs: result['data'][0]['name'],
							//tag: result['data'][0]['tag'],
							//route_id: result['data'][0]['route_id'],
						});
						
						setTimeout(() => {
								//this.routedetails(result['data'][0]['route_id'],result['data'][0]['tag'])
							}, 100);
						
					}else{
						this.setState({
							school_list: [],
							
						});
					}
				}
			});
			
			
	}
  }
  
  routedetails(route_id,tag){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {school_id : school_id,user_id : user_id,route_id:route_id,tag}
			getData('erp/route_tracker_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							route_list: result['data'],
						});
					}else{
						this.setState({
							route_list: [],
							
						});
					}
				}
			});
	}
  }
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	  };
	
	onChange = checkedList => {
		this.setState({
		  checkedList,
		  indeterminate: !!checkedList.length && checkedList.length < plainOptions.length,
		  checkAll: checkedList.length === plainOptions.length,
		});
	  };

  onCheckAllChange = e => {
		this.setState({
		  checkedList: e.target.checked ? plainOptions : [],
		  indeterminate: false,
		  checkAll: e.target.checked,
		});
	  };
	  
	openQuantity(e,tag,route_id){
	this.setState({ tabs: e,tag:tag,route_id:route_id });
			setTimeout(() => {
								this.routedetails(route_id,tag)
			}, 100);
	}  
	
	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		<div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                    
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Route Tracker</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/transport-setup/index">Transport Setup</a>
                           </li>
						   
						  
                           <li class="breadcrumb-item active">Route Tracker
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>  
		 
        
		<div class="desktop-view">
		<div class="col s12 m12 ex-padd">               
			<div id="main" class="bg-off">
				<div class="row">
				<div class="container">
					<div class="col m12 mt-10 mb-10 pb-10">
						
						
						
						<div class="desktop-tab">
								{this.state.school_list.map((list) => ( 
								<div className={`mobile-tab-view ${this.state.tabs == list.name ?'':'tab-none'} `} onClick={this.openQuantity.bind(this,list.name,list.tag,list.route_id)} >
								{list.name}</div>	
								))}
								</div>
						
					</div>
					
				</div>
				</div>
				<div class="row mt-50">
				<div class="container">
					 <Link to={`${process.env.PUBLIC_URL}/transport-setup/route-tracker-history`}>
					<div class="col m12 mt-10 mb-10 text-right">
							<Button className="snd-btn " >Route History</Button>
					</div>
					</Link>
				</div>
				</div>
			</div>
			
            <div class="container ">
			   <div class="col s12 m12 mb-20 mt-10 iq-card2 flow-root">
                  <section class="invoice-list-wrapper section food mh-400">
					
					{this.state.route_list.map((data) => (
					<div class="col m12 s12 bg-white pt-20 pb-20 mh-500">
							
						
						{data.stop_array.map((list) => (	
							<>
							{(() => {
									if (list.type == "start" || list.type == "end") {
										return (
													<Timeline.Item color="blue">
														<div class="row no-margin">
																<div class="children timeline communication ">
																	<Collapse
																		bordered={false}
																	  >
																		<Panel header={list.Stop} key={list.id}>
																			<div class="col m12 s12 no-padd">
																				<div class="col m12 s12 profile-details no-padd">	
																					{/* <p class="mb-0 pb-0 schedule">Scheduled Time : 1:05 PM</p>
																					<p class="mb-0 pb-0 arrive">Arrival Time : 1:05 PM</p> */}
																				</div>
																			</div>
																		</Panel>
																		
																	  </Collapse>
																</div>
														</div>
													</Timeline.Item >
										)
									}else{
										return (
													<Timeline.Item color="blue">
														<div class="row no-margin">
															<div class="children timeline communication ">
																<Collapse
																	bordered={false}
																  >
																	<Panel header={list.Stop} key={list.id}>
																		<div class="col m12 s12 no-padd">
																			<div class="col m12 s12 profile-details no-padd">	
																				<p class="mb-0 pb-0 schedule">Scheduled Time : {list.pickup_time}</p>
																				<p class="mb-0 pb-0 arrive">Arrival Time : {list.arrrival_time}</p>
																			</div>
																			<div class="col m12 s12 bus-track profile-details no-padd">	
																				<Checkbox.Group  name="children_id[]" onChange={this.onChangechecked}>
																				{list.student_array.map((student)=> (	
																				<>
																				   
																				   
																				   {(() => {
																						if (student.is_travel == "1") {
																							return (
																									<Checkbox value={1} id={1}><label class="w-m" for={1} defaultChecked={true} readonly>
																									   <div class="center"><img src={person} class="atd-img" /> {student.name} <img src={bus} class="bus-img"/></div>
																									   </label>
																								   </Checkbox>
																							)
																						}else{
																							return (
																									<Checkbox value={1} id={1}><label class="w-m" for={1} defaultChecked={true} readonly>
																									   <div class="center"><img src={person} class="atd-img" /> {student.name}</div>
																									   </label>
																								   </Checkbox>
																							)
																						}
																					})()}
																				   
																				</>   
																				))}   
																					
																				   
																				</Checkbox.Group>
																			</div>
																			
																		</div>
																	</Panel>
																	
																  </Collapse>
															</div>
													</div>
												</Timeline.Item >
										)
									
									}
							})()}
							
							</>
							
						))}	
						
						<div class="col m12 mt-20 children bg-blue attendance route-track bt pt-20">
												<h5>Driver Details</h5>
														  <div class="col m3 center"> <img src={deliveryman} class="route-track-img"/> </div>
														  <div class="col m9 text-left"> 
															<div class="col m12 mt-10"> <h6>Driver Name : {data.driver_name}</h6></div> 
															<div class="col m12 mt-10"> <h6>Phone Number : {data.driver_mobile}</h6></div> 
														  </div>
														  
						</div>
						
					</div>
				))}	
					
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
         </div>
         </div>
		 
		<div class="mobile-view">
				<div class="mob-drawer-top">
						<button  className="right drawer-btn"> <Link to={`${process.env.PUBLIC_URL}/transport-setup/route-tracker-history`}> History </Link></button>
				</div>	
				<div class="col s12 m12 ex-padd ">
					<div id="main" class="bg-off">
						<div class="row">
						<div class="container">
							
								<div class="mobile-tab">
								{this.state.school_list.map((list) => ( 
								<div className={`mobile-tab-view ${this.state.tabs == list.name ?'':'tab-none'} `} onClick={this.openQuantity.bind(this,list.name,list.tag,list.route_id)} >
								{list.short_name}</div>	
								))}
								</div>
								
								{this.state.route_list.map((data) => (
									<div class="col m12 s12 bg-white pt-20 pb-20 mh-500 route-timeline">
											
										
										{data.stop_array.map((list) => (	
											<>
											{(() => {
													if (list.type == "start" || list.type == "end") {
														return (
																	<Timeline.Item color="blue">
																		<div class="row no-margin">
																				<div class="children timeline communication ">
																					<Collapse
																						bordered={false}
																					  >
																						<Panel header={list.Stop} key={list.id}>
																							<div class="col m12 s12 no-padd">
																								<div class="col m12 s12 profile-details no-padd">	
																									{/* <p class="mb-0 pb-0 schedule">Scheduled Time : 1:05 PM</p>
																									<p class="mb-0 pb-0 arrive">Arrival Time : 1:05 PM</p> */}
																								</div>
																							</div>
																						</Panel>
																						
																					  </Collapse>
																				</div>
																		</div>
																	</Timeline.Item >
														)
													}else{
														return (
																	<Timeline.Item color="blue">
																		<div class="row no-margin">
																			<div class="children timeline communication ">
																				<Collapse
																					bordered={false}
																				  >
																					<Panel header={list.Stop} key={list.id}>
																						<div class="col m12 s12 no-padd">
																							<div class="col m12 s12 profile-details no-padd">	
																								<p class="mb-0 pb-0 schedule">Scheduled Time : {list.pickup_time}</p>
																								<p class="mb-0 pb-0 arrive">Arrival Time : {list.arrrival_time}</p>
																							</div>
																							<div class="col m12 s12 bus-track mt-5 profile-details no-padd">	
																								
																								{list.student_array.map((student)=> (	
																								<>
																								   
																								   
																								   {(() => {
																										if (student.is_travel == "1") {
																											return (
																													
																												   <div class="col m2 s4 pt-10 center no-padd">
																														<h6 class="student-div"><img src={person} class="atd-img" /> {student.name} <img src={bus} class="bus-img"/></h6>
																													</div>
																											)
																										}else{
																											return (
																													<div class="col m2 s4 pt-10 center no-padd">
																														<h6 class="student-div"><img src={person} class="atd-img" /> {student.name} </h6>
																													</div>
																											)
																										}
																									})()}
																								   
																								</>   
																								))}   
																									
																								   
																								
																							</div>
																							
																						</div>
																					</Panel>
																					
																				  </Collapse>
																			</div>
																	</div>
																</Timeline.Item >
														)
													
													}
											})()}
											
											</>
											
										))}	
										
										<div class="col m12 mt-20 children bg-blue attendance route-trackno-padd">
											<div class="bt pt-10">
																	<h5>Driver Details</h5>
																			  <div class="col m3 s2 center no-padd"> <img src={deliveryman} class="route-track-img"/> </div>
																			  <div class="col m9 s10 text-left no-padd"> 
																				<div class="col m12 "> <h6 class="mb-0">Driver Name : <b>{data.driver_name} </b></h6></div> 
																				<div class="col m12"> <h6 class="mb-0">Phone Number : <b> {data.driver_mobile} </b></h6></div> 
																			  </div>
																			  
											</div>
										</div>
										
									</div>
								))}	
								
							
						</div>
						</div>
					</div>
				</div>
			<div class="mt-50">		
			</div>
		</div>
		 
		 
		 
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
